import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import styles from './trip-route-details-transport-mode.module.scss';

export interface TripRouteDetailsTransportModeProps {
  /** The class name to apply */
  className?: string;
  /** Whether the item is in combined accordion or not */
  isStandAlone?: boolean;
  /** The item list to show combined accordion */
  item: Content.Properties.TransportModeItem;
  /** An event that is triggered on click */
  onClick?: () => void;
}

const getIconName = (name: string): IconName => {
  switch (name) {
    case 'boat':
      return 'Boat';

    case 'bus':
      return 'Bus';

    case 'plane':
      return 'PlaneTakeOff';

    case 'train':
      return 'Train';

    default:
      return 'Car';
  }
};

const TripRouteDetailsTransportMode = ({
  className,
  isStandAlone = false,
  item,
}: TripRouteDetailsTransportModeProps) => {
  return (
    <div
      className={classNames(styles.component, className, {
        [styles.isStandAlone]: isStandAlone,
      })}
    >
      <div className={styles.divider} />

      <Icon
        className={styles.icon}
        name={getIconName(item.transportMode)}
        size={24}
      />

      <div className={styles.info}>
        <Typography className={styles.headline} tagStyle="bodySmallBold">
          {item.headline}
        </Typography>

        <Typography className={styles.text} tagStyle="bodySmall">
          {item.text}
        </Typography>
      </div>

      <div className={styles.divider} />
    </div>
  );
};

TripRouteDetailsTransportMode.displayName = 'TripRouteDetailsTransportMode';

export default TripRouteDetailsTransportMode;
